import React from "react";
const Chevron = ({
  title,
  className
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, title && /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.495 27.294l-2.828-2.828 8.485-8.486-8.485-8.485 2.828-2.828L24.81 15.98z"
  }));
};
export default Chevron;